import React from 'react';
import {
  registrationStateTypes,
  useRegistrationSubscribe,
} from '../../../../services/acceptanceRegistration';
import RegistrationAddressDescription from '../../ui/RegistrationAddressDescription';

const AddressDescription = () => {
  const { status, value } = useRegistrationSubscribe({
    type: registrationStateTypes.address,
  });

  if (status !== 'success') {
    return null;
  }

  return <RegistrationAddressDescription room={value} />;
};

export default AddressDescription;
